const NewCanvasViewer = () =>
  import(
    /* webpackChunkName: "NewCanvasViewer" */ `@/components/rapsotec/projects/project/avis/NewCanvasViewer.vue`
  );
const Viewer = () =>
  import(/* webpackChunkName: "Viewer" */ `@/components/rapsotec/projects/project/avis/Viewer.vue`);

export default [
  {
    path: "viewer/:topicType?/:guid?",
    name: "viewer",
    component: Viewer,
  },
  {
    path: "newcanevasviewer/:topicType?/:guid?",
    name: "newCanevasViewer",
    component: NewCanvasViewer,
  },
];
